import getApiClient from '@/plugins/api-client'
import ImageUploader from '@/components/ImageUploader'
import LinkInput from '@/components/LinkInput'
import ButtonInput from '@/components/ButtonInput'
import ColorInput from '@/components/ColorInput'
import TextEditor from '@/components/TextEditor'

export default {
  name: 'BlockForm',
  components: {
    ImageUploader,
    LinkInput,
    ButtonInput,
    ColorInput,
    TextEditor,
  },
  props: {
    value: {
      type: Object,
      required: false,
    },
    isNew: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => {
    return {
      block: {
        type: null,
        fields: [],
      },
      blockTypes: [],
      api: null,
      id: null,
    }
  },
  mounted: function () {
    this.api = getApiClient(this.$store)
    this.id = this.$route.params.id ?? null

    this.loadBlock()
    this.loadBlockTypes()
  },
  emit: ['input', 'cancel'],
  methods: {
    loadBlock: function () {
      if (this.value && !this.isNew) {
        this.block = this.value
        this.id = this.block.id
        return
      }

      if (this.id && !this.isNew) {
        this.api.get(`/blocks/${this.id}`)
          .then(result => {
            this.block = result.data
          })
          .catch(error => {
            console.info(error)
          })
      }
    },
    loadBlockTypes: function () {
      this.api.get('/block_types')
        .then(result => {
          this.blockTypes = result.data['hydra:member']
        })
        .catch(error => {
          console.info(error)
        })
    },
    save: function () {
      let method = 'post'
      let path = '/blocks'
      const headers = {}
      if (this.id && !this.isNew) {
        method = 'patch'
        path = `/blocks/${this.id}`
        headers['Content-Type'] = 'application/merge-patch+json'
      }

      const data = this.prepareData(this.block)

      this.api[method](path, data, { headers })
        .then(result => {
          this.$store.commit('app/raiseSuccess', 'Bloco salvo com sucesso')
          this.$emit('input', result.data)
        })
        .catch(() => {
          this.$store.commit('app/raiseError', 'Falha ao salvar bloco')
        })
    },

    prepareData: function (data) {
      const value = JSON.parse(JSON.stringify(data))

      // eslint-disable-next-line no-unused-expressions
      value?.fields?.forEach(function (field) {
        if (typeof field.field['@id'] !== 'undefined') {
          field.field = field.field['@id']
        }

        if (!value.id) {
          field.id = undefined
          field.settings = undefined
        }
      })

      if (typeof value.type['@id'] !== 'undefined') {
        value.type = value.type['@id']
      }
      return value
    },
  },
  watch: {
    'block.type': function (value) {
      const self = this
      if (self.block.fields.length > 0) {
        return
      }
      value.fields.forEach(function (field) {
        self.block.fields.push({
          field: {
            '@id': field['@id'],
            id: field.id,
            type: field.type,
            slug: field.slug,
            name: field.name,
            settings: field.settings,
          },
          id: field.id,
          slug: field.slug,
          type: field.type,
          value: field.initialValue || (field.type === 'html' ? '' : null),
        })
      })
    },
  },
}
